package ru.villawonka.app.presentation.screens.splash.viewmodel

import ru.villawonka.app.common.mvvm.SingleLiveEvent
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.domain.model.SearchParamsDomain

sealed class SplashUIEvent : SingleLiveEvent {
    open val isNeedSetupScreenShow: Boolean = false

    data class OpenSearchScreen(
        override val isNeedSetupScreenShow: Boolean,
        val searchParamsDomain: SearchParamsDomain
    ) : SplashUIEvent()

    data class OpenPostCardScreen(
        override val isNeedSetupScreenShow: Boolean,
        val postId: Int,
        val postType: PostTypeDomain,
    ) : SplashUIEvent()
}